import { render } from "./SendMessageBtn.vue?vue&type=template&id=7ee91e5d"
import script from "./SendMessageBtn.vue?vue&type=script&lang=ts"
export * from "./SendMessageBtn.vue?vue&type=script&lang=ts"
script.render = render

export default script